import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LayoutRoutingModule } from './layout-routing.module';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavebarComponent } from './navebar/navebar.component';
import { BaseComponent } from './base/base.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material/material.module';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    SidebarComponent,
    NavebarComponent,
    BaseComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    LayoutRoutingModule,
    MaterialModule,
    SharedModule
  ]
})
export class LayoutModule { }
